export { SuiLocalizationModule, SuiLocalizationService } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/behaviors/localization/public.js
// module id = 1079
// module chunks = 0